import type { FaireProductEntity } from "../../entity_types/product";

export const p_xez4csxt4c: FaireProductEntity = {
  token: "p_xez4csxt4c",
  type: "product",
  name: "Apple Crumble Ashwagandha - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/f3c1ea659376c62957bc99000d3dba839854a0b1763e5895750493cc107ce7e4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1ccdd34bc91da9e9a2db475bf9a6b2de08378c559fde0a87b7db884801bbbb2.png"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND\n\nThis nourishing dessert tea is refreshing and cozy, like digging into a crisp apple crumble laced with cinnamon and warming spices. With real apple pieces and vanilla bean, calming tulsi, adaptogenic ashwagandha, you’ll mellow out with sugar-free superfoods in every sip. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * A soothing all day caffeine-free tea \n * To bolster immunity \n * Mid-day to slow down and sip in mindfulness \n * To calm your nerves and promote calmness and clarity \n*Caffeine-free\n",
  tags: [],
  msrpDollars: 116,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:38.130Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
